"use client";

import { useEffect, useState } from "react";
import { useFansUnitedSDK } from "fansunited-data-layer/client";
import type { TierConfig, BadgeDefinition } from "../types";
interface UseLoyaltyConfigReturn {
  tierConfigs: TierConfig[];
  badgeDefinitions: Record<string, BadgeDefinition[]>;
  isLoading: boolean;
}
export function useLoyaltyConfig(): UseLoyaltyConfigReturn {
  const sdk = useFansUnitedSDK();
  const [tierConfigs, setTierConfigs] = useState<TierConfig[]>([]);
  const [badgeDefinitions, setBadgeDefinitions] = useState<Record<string, BadgeDefinition[]>>({});
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!sdk) return;
    const fetch = async () => {
      setIsLoading(true);
      try {
        const configResult = await sdk.loyalty.getConfigV2();
        if (configResult?.rewards?.tiers) {
          setTierConfigs(configResult.rewards.tiers.filter((t: TierConfig & {
            enabled?: boolean;
          }) => t.enabled !== false).map((t_0: TierConfig) => ({
            id: t_0.id,
            label: t_0.label,
            points: t_0.points
          })));
        }
        if (configResult?.rewards?.badges) {
          const badges = configResult.rewards.badges;
          const defs: Record<string, BadgeDefinition[]> = {};
          const categoryKeys = ["predictor", "topX", "matchQuiz", "games", "football", "classicQuizzes", "eitherOr", "discussions"];
          const badgesRecord = badges as unknown as Record<string, BadgeDefinition[]>;
          for (const key of categoryKeys) {
            const categoryBadges = badgesRecord[key];
            if (Array.isArray(categoryBadges) && categoryBadges.length > 0) {
              defs[key] = categoryBadges.filter(b => b.enabled !== false);
            }
          }
          const voting = (badges as unknown as Record<string, unknown>).voting;
          if (voting && typeof voting === "object") {
            const votingBadges: BadgeDefinition[] = [];
            const votingObj = voting as Record<string, BadgeDefinition[]>;
            if (Array.isArray(votingObj.potm)) votingBadges.push(...votingObj.potm);
            if (Array.isArray(votingObj.poll)) votingBadges.push(...votingObj.poll);
            if (votingBadges.length > 0) {
              defs.voting = votingBadges.filter(b_0 => b_0.enabled !== false);
            }
          }
          setBadgeDefinitions(defs);
        }
      } catch (err) {
        console.error("Failed to load loyalty config:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  }, [sdk]);
  return {
    tierConfigs,
    badgeDefinitions,
    isLoading
  };
}